module.exports = __webpack_public_path__ + "font/3c89649614630d9bf36deb57c9a599a8.otf";